export interface Task {
    assignee?: string,
    attachments?: Attachment[],
    comments?: Comment[],
    createdAt: string,
    cycle?: string,
    description?: string,
    dueDate?: string
    id: string,
    parentTask?: Task | null,
    priority?: TaskPriority,
    project?: string
    status?: TaskStatus,
    subTasks?: Task[],
    tags?: string[],
    title: string,
    updatedAt: string
}

export interface Comment {
    attachments?: Attachment[],
    author: string,
    content: string,
    createdAt: string,
    id: string,
    updatedAt: string
} 

export interface Attachment {
    author: string,
    createdAt: string,
    id: string,
    name: string,
    updatedAt: string
    url: string
}

export enum TaskStatus {
    ARCHIVED = 'archived',
    BLOCKED = 'blocked',
    CANCELLED = 'cancelled',
    COMPLETED = 'completed',
    DELETED = 'deleted',
    DRAFT = 'draft',
    IN_PROGRESS = 'in_progress',
    ON_HOLD = 'on_hold',
    PENDING = 'pending',
    REVIEW = 'review'
}

export const TaskStatusMap = {
    [TaskStatus.PENDING]: {
        label: 'Pending',
        value: TaskStatus.PENDING,
    },
    [TaskStatus.IN_PROGRESS]: {
        label: 'In Progress',
        value: TaskStatus.IN_PROGRESS,
    },
    [TaskStatus.COMPLETED]: {
        label: 'Completed',
        value: TaskStatus.COMPLETED,
    },
    [TaskStatus.CANCELLED]: {
        label: 'Cancelled',
        value: TaskStatus.CANCELLED,
    },
    [TaskStatus.BLOCKED]: {
        label: 'Blocked',
        value: TaskStatus.BLOCKED,
    },
    [TaskStatus.ON_HOLD]: {
        label: 'On Hold',
        value: TaskStatus.ON_HOLD,
    },
    [TaskStatus.REVIEW]: {
        label: 'Review',
        value: TaskStatus.REVIEW,
    },
    [TaskStatus.DRAFT]: {
        label: 'Draft',
        value: TaskStatus.DRAFT,
    },
    [TaskStatus.ARCHIVED]: {
        label: 'Archived',
        value: TaskStatus.ARCHIVED,
    },
    [TaskStatus.DELETED]: {
        label: 'Deleted',
        value: TaskStatus.DELETED,
    },
}

export enum TaskPriority {
    CRITICAL = 'critical',
    HIGH = 'high',
    LOW = 'low',
    MEDIUM = 'medium'
}

export const TaskPriorityMap = {
    [TaskPriority.LOW]: {
        label: 'Low',
        value: TaskPriority.LOW,
    },
    [TaskPriority.MEDIUM]: {
        label: 'Medium',
        value: TaskPriority.MEDIUM,
    },
    [TaskPriority.HIGH]: {
        label: 'High',
        value: TaskPriority.HIGH,
    },
    [TaskPriority.CRITICAL]: {
        label: 'Critical',
        value: TaskPriority.CRITICAL,
    },
}